import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import SubscriptionPlansPage from '../settings/components/SubscriptionPlansPage';
import OperatorStripeSettingsPage from './OperatorStripeSettingsPage';

/**
 * Consolidated operator "Plans & Billing" page. Everything plan/subscription
 * related lives here under two tabs:
 *   - Plans: create/edit plans, mark free-tier (trial) / enterprise (talk to
 *     sales), set Stripe price ids, publish per plan, assign tenants, retention.
 *   - Stripe & Signup: Stripe API keys + webhook secret, the GLOBAL master
 *     "enable public Subscribe" switch, success/cancel URLs, test connection.
 */
const OperatorPlansBillingPage = () => {
  const [tab, setTab] = useState(0);
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.25 }}>Plans &amp; Billing</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Subscription plans, the public Subscribe / signup flow, and Stripe configuration — all in one place.
      </Typography>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Plans" />
        <Tab label="Stripe & Signup" />
      </Tabs>
      <Box hidden={tab !== 0}>{tab === 0 && <SubscriptionPlansPage />}</Box>
      <Box hidden={tab !== 1}>{tab === 1 && <OperatorStripeSettingsPage />}</Box>
    </Box>
  );
};

export default OperatorPlansBillingPage;
